<div class="quick-create-panel" (click)="$event.stopPropagation()">
  @for (category of quickCreateCategories; track category) {
    <div class="quick-create-group">
      <div class="group-label">{{ category.title }}</div>
      <div class="group-grid">
        @for (item of category.items; track item) {
          <div class="grid-item"
            (click)="openModal(item.label)">
            <div class="grid-item-icon" [style.background-color]="category.color">
              <i class="fa {{ item.icon }}"></i>
            </div>
            <span class="grid-item-label">{{ item.label }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
